import React, { useState, useEffect } from 'react';
import { Button, Cards, Container, ExpandableSection, Grid, Header, KeyValuePairs, Link, Modal, Slider, SpaceBetween, StatusIndicator, Tabs, Tiles, TilesProps, Form, Table, Badge, FormField,  Input, Pagination, TextFilter } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Box from '@cloudscape-design/components/box';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { formatPhone, getParameter, storeJWT } from '../../../commons/functions';
import Select, { SelectProps } from '@cloudscape-design/components/select';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { mdiBoomGateArrowUpOutline, mdiCalendarOutline, mdiCheckCircleOutline, mdiCloseCircleOutline, mdiDeleteClockOutline, mdiEmailOpenOutline, mdiHelpCircleOutline, mdiLockOpenOutline, mdiLockOutline, mdiRefresh, mdiTimerEditOutline, mdiTimerPlusOutline, mdiTimerSandEmpty } from '@mdi/js';
import { date } from 'zod';
import Icon from '@mdi/react';
type OptionDefinition = SelectProps.Option;


interface Status {
    label: string;
    value: string;
    description?: string;
    iconName?: string;
}

interface optionSelect {
    label: string;
    value: string;
}
interface AccessMode {
    label: string;
    value: string;
    description?: string;
    iconName?: string;
}

interface AccessType {
    label: string;
    value: string;
    description?: string;
    iconName?: string;
    idAutorizado: number;
    idAcceso: number;
    hashAutorizado: string;
}

interface GuestType {
    label: string;
    value: string;
    description?: string;
    iconName?: string;
}

type LogItem = {
    idLog: number;
    fecha: string;
    hora: string;
    status: string;
    log: string;
    user: string;
    objTime: string;
};

export const UsersEditPage = () => {
    const storeAdmin = useStoreAdmin();
    const { idPropiedad, setIdPropiedad } = useGlobalState();
    const { JWT, setJWT } = useGlobalState();
    const [isMapOpen, setIsMApOpen] = useState(false);
    const [btnDeleteAccessDisabled, setBtnDeleteAccessDisabled] = useState(true);
    const [mapUrl, setMapUrl] = useState('');
    const [nombre, setNombre] = useState('');
    const [apellido, setApellido] = useState('');
    const [email, setEmail] = useState('');
    const [movil, setMovil] = useState('');
    const [unidad, setUnidad] = useState('');
    const [idUnidad, setIdUnidad] = useState(0);
    const { setLoading } = useGlobalState();
    const [logs, setLogs] = useState<LogItem[]>([]);
    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    const [user, setUser] = useState<any>();

    const [accesses, setAccesses] = useState<AccessType[]>([]);

    const { gData, setGData } = useGlobalState();
    const [selectedAccesses, setSelectedAccesses] = useState<AccessType[]>([]);

    const [units, setUnits] = useState<OptionDefinition[]>([]);
    const [selectedUnit, setSelectedUnit] = useState<OptionDefinition | null>(
        units.find(opt => opt.value === idUnidad.toString()) || null
    );
    // Example input string


    /*
        const handleStatusChange = (event: { detail: { value: string } }) => {
            setStatus(event.detail.value);
            console.log('Selected Status Value:', event.detail.value);
        };
        const statuses: Status[] = [
            { label: 'Activo', value: '1', description: 'El dispositivo se encuentra habilitado para operar normalmente', iconName: 'status-positive', },
            { label: 'Mantenimiento', value: '0', description: 'El dispositivo solo puede ser operado por un administrador', iconName: 'status-warning', },
            { label: 'Desactivado', value: '-1', description: 'El dispositivo no permite efectuar aperturas', iconName: 'status-negative', },
        ];
        const accessModes: AccessMode[] = [
            { label: "APP", description: "2Apertura directa via App (Requiere conectividad de usuario", value: "APP" },
            { label: "BLE", description: "2Apertura utilizando comunicación Bluetooth BLE", value: "BLE" },
            { label: "Lectura QR", description: "2Usuario lee código QR en acceso", value: "QR.READ" },
            { label: "Mostrar QR", description: "2Usuario despliega código QR a fiscalizador", value: "SHOW.QR" },
        ]
        const accessTypes: AccessType[] = [
            { label: "Aplicación", description: "1Apertura directa via App (Requiere conectividad de usuario", value: "HTTP" },
            { label: "Lectura QR", description: "1Usuario escanea código QR en acceso", value: "QR.CODE" },
            { label: "Mostrar QR", description: "1Usuario despliega código QR para fiscalización", value: "SHOW.QR" },
            { label: "Bluetooth BLE", description: "1Apertura utilizando comunicación Bluetooth BLE", value: "BLE" },
        ]
        useEffect(() => {
            const selectedValues = accessMode.split(',');
            const matchedModes = accessModes.filter(mode => selectedValues.includes(mode.value));
            setSelectedAccessModes(matchedModes);
        }, [accessMode]);
        useEffect(() => {
            const selectedValues = accessType.split(',');
            const matchedModes = accessTypes.filter(mode => selectedValues.includes(mode.value));
            setSelectedAccessTypes(matchedModes);
        }, [accessType]);
    */
    const id = getParameter(window.location.hash, 'id');
    const handleDeleteAccesses = async () => {
        const body: { hashAutorizados: string[]; idUnidad: number } = { hashAutorizados: [], idUnidad: idUnidad };
        let hashAutorizados: any[] = [];
        selectedAccesses.forEach((access) => {
            hashAutorizados.push(access.hashAutorizado)
        });
        body.hashAutorizados = hashAutorizados;

        try {
            setLoading(true)
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/users/delete',
                    'JWT': JWT,

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            storeAdmin(data);
            if (data.code === 0) {
                handleRefresh()
            }

        } catch (error) {
            console.error('Error fetching accesses:', error);
        } finally {
            setLoading(false)
        }
    }

    const handleRefresh = async () => {
        try {
            setLoading(true)
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/users/get',
                    'JWT': JWT,

                },
                body: JSON.stringify({
                    idControl: id,
                    accesses: true,
                    units: true,
                    logs: true,
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            storeAdmin(data);
            if (data.code === 0) {
                console.log("TEST")
                setUser(data.user)
                setUnits(data.units)
                setNombre(data.user.nombre)
                setApellido(data.user.apellido)
                setEmail(data.user.email)
                setMovil(data.user.movil)
                setUnidad(data.user.unidad)
                setIdUnidad(data.user.idUnidad)
                setLogs(data.user.logs)
                const mapped: AccessType[] = data.user.accesses.map((item: { acceso: string; idAcceso: number; idAutorizado: number; hashAutorizado: string }) => ({
                    label: item.acceso.toString(),
                    value: item.idAcceso.toString(),
                    idAcceso: item.idAcceso,
                    idAutorizado: item.idAutorizado,
                    hashAutorizado: item.hashAutorizado,
                }));
                setAccesses(mapped);

                const unitOptions: optionSelect[] = (data?.units || []).map((unit: { idUnidad: number; unidad: string }) => ({
                    label: unit.unidad,
                    value: unit.idUnidad.toString(),
                }));
                setUnits(unitOptions)

            }

        } catch (error) {
            console.error('Error fetching accesses:', error);
        } finally {
            setLoading(false)
        }
    };


    const handleUpdate = async () => {
        try {
            setLoading(true)
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/users/update',
                    'JWT': JWT,

                },
                body: JSON.stringify({
                    idControl: id,
                    accesses: true,
                    units: true,
                    logs: true,
                    idUnidad: idUnidad,
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            storeAdmin(data);
            if (data.code === 0) {
                console.log("TEST")
                setUser(data.user)
                setUnits(data.units)
                setNombre(data.user.nombre)
                setApellido(data.user.apellido)
                setEmail(data.user.email)
                setMovil(data.user.movil)
                setUnidad(data.user.unidad)
                setIdUnidad(data.user.idUnidad)
                setLogs(data.user.logs)
                const mapped: AccessType[] = data.user.accesses.map((item: { acceso: string; idAcceso: number; idAutorizado: number; hashAutorizado: string }) => ({
                    label: item.acceso.toString(),
                    value: item.idAcceso.toString(),
                    idAcceso: item.idAcceso,
                    idAutorizado: item.idAutorizado,
                    hashAutorizado: item.hashAutorizado,
                }));
                setAccesses(mapped);

                const unitOptions: optionSelect[] = (data?.units || []).map((unit: { idUnidad: number; unidad: string }) => ({
                    label: unit.unidad,
                    value: unit.idUnidad.toString(),
                }));
                setUnits(unitOptions)

            }

        } catch (error) {
            console.error('Error fetching accesses:', error);
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        setBtnDeleteAccessDisabled(selectedAccesses.length === 0)
    }, [selectedAccesses]);

    useEffect(() => {

        handleRefresh();
    }, []);
    useEffect(() => {
        setSelectedUnit(units.find(opt => opt.value === idUnidad.toString()) || null)
    }, [units]);

    return (
        <CustomAppLayout
            toolsHide={true}
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Usuarios', href: '#users' },
                        { text: 'Listado', href: '#users/list' },
                        { text: 'Editar', href: '#config/access.edit' },
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <Form
                        header={
                            <Header
                                variant="h2"
                            >
                                Configuración de usuario {formatPhone(movil)}
                            </Header>
                        }
                        actions={

                            <SpaceBetween direction="horizontal" size="xs">
                                <Button variant="link" href='#users/list'>
                                    Atrás
                                </Button>
                                <Button variant='primary' onClick={() => handleUpdate()}>
                                    Actualizar
                                </Button>
                            </SpaceBetween>
                        }
                    >
                        {/* Add content here if needed */}
                        <Container>
                            <Tabs
                                tabs={[
                                    {
                                        label: "Info",
                                        id: "first",
                                        content:
                                            <KeyValuePairs
                                                columns={3}
                                                items={[
                                                    { label: "Nombre", value: nombre },
                                                    { label: "Apellido", value: apellido },
                                                    { label: "Email", value: email },
                                                    { label: "Móvil", value: formatPhone(movil) },
                                                    {
                                                        label: "Unidad",
                                                        value: (
                                                            <Select
                                                                options={units}
                                                                selectedOption={selectedUnit}
                                                                onChange={({ detail }) => {
                                                                    setSelectedUnit(detail.selectedOption);
                                                                    setIdUnidad(Number(detail.selectedOption?.value) || 0);
                                                                }}
                                                            ></Select>
                                                        ),
                                                    },
                                                ]}
                                            />
                                    },
                                    {
                                        label: "Accesos",
                                        id: "second",
                                        content:
                                            <>
                                                <Cards
                                                    cardDefinition={{
                                                        header: item => (
                                                            `${item.label}`
                                                        ),
                                                    }}
                                                    cardsPerRow={[
                                                        { cards: 1 },
                                                        { minWidth: 500, cards: 3 }
                                                    ]}
                                                    items={accesses}
                                                    selectionType="multi"
                                                    trackBy="value"  // ✅ Use correct unique key
                                                    selectedItems={selectedAccesses}
                                                    onSelectionChange={({ detail }) => {
                                                        setSelectedAccesses(detail.selectedItems);
                                                    }}
                                                    entireCardClickable
                                                />
                                                <Button variant='primary' onClick={handleDeleteAccesses} disabled={btnDeleteAccessDisabled}>Eliminar seleccionados</Button>
                                            </>
                                    },
                                    {
                                        label: "Seguridad",
                                        id: "third",
                                        content: "Third tab content area",
                                    },
                                    {
                                        label: "Bitácoras",
                                        id: "4",
                                        content:
                                            <Table
                                                stripedRows
                                                wrapLines
                                                stickyHeader
                                                //onSelectionChange={handleSelectionChange}

                                                columnDefinitions={[

                                                    {
                                                        id: "fecha",
                                                        header: "Fecha",
                                                        cell: (item) => item.fecha,
                                                        width: 110,
                                                    },
                                                    {
                                                        id: "hora",
                                                        header: "Hora",
                                                        cell: (item) => item.hora,
                                                        width: 110,
                                                    }, {
                                                        id: "status",
                                                        header: "Categoría",
                                                        cell: (item) => {
                                                            let statusText = '';
                                                            let statusColor: "red" | "blue" | "grey" | "green" | "yellow" | "severity-critical" | "severity-high" | "severity-medium" | "severity-low" | "severity-neutral" | "" | undefined = "grey";
                                                            let statusIcon = mdiHelpCircleOutline;


                                                            if (item.status === 'OPEN.COMPLETE') {
                                                                statusText = "Apertura";
                                                                statusColor = 'green';
                                                                statusIcon = mdiCheckCircleOutline
                                                            } else if (item.status === 'OPEN.PENDING') {
                                                                statusText = "Apertura";
                                                                statusColor = 'severity-low';
                                                                statusIcon = mdiTimerSandEmpty
                                                            } else if (item.status === 'OPEN.BUSY') {
                                                                statusText = "Apertura";
                                                                statusColor = 'severity-high';
                                                                statusIcon = mdiCloseCircleOutline
                                                            } else if (item.status === 'MANUAL.OPEN') {
                                                                statusText = "Manual";
                                                                statusColor = "blue";
                                                                statusIcon = mdiBoomGateArrowUpOutline;
                                                            } else if (item.status === 'ACCESS.BLOCK') {
                                                                statusText = "Acceso";
                                                                statusColor = "severity-neutral";
                                                                statusIcon = mdiLockOutline
                                                            } else if (item.status === 'ACCESS.UNBLOCK') {
                                                                statusText = "Acceso";
                                                                statusColor = "severity-neutral";
                                                                statusIcon = mdiLockOpenOutline
                                                            } else if (item.status === 'UNIT.BLOCK') {
                                                                statusText = "Unidad";
                                                                statusColor = "severity-neutral";
                                                                statusIcon = mdiLockOutline
                                                            } else if (item.status === 'UNIT.UNBLOCK') {
                                                                statusText = "Unidad";
                                                                statusColor = "severity-neutral";
                                                                statusIcon = mdiLockOpenOutline
                                                            } else if (item.status === 'POLICY.ADD') {
                                                                statusText = "Unidad";
                                                                statusColor = "severity-neutral";
                                                                statusIcon = mdiTimerPlusOutline
                                                            } else if (item.status === 'POLICY.DELETE') {
                                                                statusText = "Unidad";
                                                                statusColor = "severity-neutral";
                                                                statusIcon = mdiDeleteClockOutline
                                                            } else if (item.status === 'POLICY.MOD') {
                                                                statusText = "Unidad";
                                                                statusColor = "severity-neutral";
                                                                statusIcon = mdiTimerEditOutline
                                                            } else if (item.status === 'GUEST.ARRIVAL') {
                                                                statusText = "Invitados";
                                                                statusColor = "severity-neutral";
                                                                statusIcon = mdiEmailOpenOutline
                                                            } else {
                                                                statusText = item.status; // Default to the item's status
                                                                statusColor = 'grey'; // Or some other default color
                                                            }

                                                            return (
                                                                <Box display="inline">
                                                                    <Badge color={statusColor}>
                                                                        {statusIcon && <Icon path={statusIcon} size={0.5} />} {statusText}
                                                                    </Badge>
                                                                </Box>
                                                            );
                                                        },
                                                        width: 150,
                                                    },
                                                    {
                                                        id: "log",
                                                        header: "Registro",
                                                        cell: item => (
                                                            <div>
                                                                <div style={{ fontWeight: "bold" }}>{item.user !== '' ? item.user : "SISTEMA"}</div>
                                                                <div style={{ color: "#666", fontSize: "12px" }}>{item.log}</div>
                                                            </div>
                                                        ),
                                                    },
                                                ]}
                                                items={logs}
                                                //selectionType="multi"
                                                trackBy="idLog"
                                                empty={<Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
                                                    <SpaceBetween size="m"><b>No tiene bitácoras para el día seleccionado</b>
                                                    </SpaceBetween>
                                                </Box>}
                                            ></Table>
                                    }
                                ]}
                            />
                            <SpaceBetween direction='vertical' size='xs'>


                            </SpaceBetween>
                        </Container>
                    </Form>

                    <Modal
                        visible={isMapOpen}
                        onDismiss={() => setIsMApOpen(false)}
                        header="Ubicación"
                        size="medium"
                    >
                        <img src={mapUrl} alt="Imagen" style={{ maxWidth: '100%', maxHeight: '80vh', display: 'block', margin: '0 auto' }} />
                    </Modal>
                </>
            }
        />
    );
};
